import React from "react";
import { FooterMiniLink } from "component-library";
import { useTranslation } from "i18n";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="my-8 max-w-[1280px]">
      <p className="mb-2.5 text-xs">
        {t("performer:profile.footer.disclaimer")}
      </p>
      <div className="flex gap-4 text-xs">
        {t("common:nav.footer.copyright")}
        <FooterMiniLink to="https://www.spotlight.com/help-and-faqs/">
          {t("common:nav.help")}
        </FooterMiniLink>
        <FooterMiniLink to="https://www.spotlight.com/the-small-print/privacy-policy/">
          {t("common:nav.links.privacyPolicy")}
        </FooterMiniLink>
        <FooterMiniLink to="https://www.spotlight.com/the-small-print/terms-conditions/">
          {t("common:nav.links.termsConditions")}
        </FooterMiniLink>
      </div>
    </div>
  );
};

export default Footer;
